module.exports = __webpack_public_path__ + "media/file_icons/audio-d6d9e538.png";